module.exports = __webpack_public_path__ + "static/media/start-recording-disabled.91a78a7d.svg";